"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractAuthInterceptor = void 0;
const UnauthorizedHttpError_1 = require("../Error/Http/UnauthorizedHttpError");
class AbstractAuthInterceptor {
    constructor(authClient) {
        this.authClient = authClient;
    }
    async request(config) {
        if (this.tokenModel.tokenIsExpired()) {
            const data = await this.authClient.refreshToken({
                refreshToken: this.tokenModel.refreshToken,
            });
            config.headers.Authorization = `Bearer ${data.token}`;
        }
        else {
            config.headers.Authorization = `Bearer ${this.tokenModel.token}`;
        }
        return config;
    }
    async responseError(error, callback) {
        let message;
        if (error.response?.data?.message &&
            (message = error.response.data.message) &&
            (message === UnauthorizedHttpError_1.UnauthorizedHttpError.EXPIRED_JWT_ERROR || message === 'jwt expired')) {
            const data = await this.authClient.refreshToken({
                refreshToken: this.tokenModel.refreshToken,
            });
            return callback(data);
        }
    }
}
exports.AbstractAuthInterceptor = AbstractAuthInterceptor;
//# sourceMappingURL=AbstractAuthInterceptor.js.map